import { axios } from '@Root/API'

export const remove = id => {
	return axios.delete(`additional-field/${id}`)
}
